import {Record} from 'water-rest/src/model/hateoas/Record';
import {EntityService} from 'water-rest/src/model/hateoas/EntityService';
import {Fetch} from "water-rest/src/fetch/Fetch";

export enum AddressSourceType {
    FIAS_MODULE = "FIAS_MODULE",
    DA_DATA = "DA_DATA",
    YANDEX = "YANDEX",
}

export enum GeocoderType {
    DA_DATA = "DA_DATA",
    YANDEX = "YANDEX",
}

export interface ISettings {
    daDataApiKey: string | null;
    mapApiKey: string | null;
    mapCoordinates: number[] | null;
    addressSource: AddressSourceType | null;
    geocoder: GeocoderType | null;
}

export class MapSettings extends Record<MapSettings> {
    daDataApiKey: string | null = null;
    mapApiKey: string | null = null;
    mapCoordinates: number[] | null = [];
    addressSource: AddressSourceType | null = null;
    geocoder: GeocoderType | null = null;

    constructor() {
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        super(mapSettingsService);
    }
}

class MapSettingsService extends EntityService<MapSettings> {
    protected type = 'map_settings';
    protected path = 'mapSettings';
    protected basePath = process.env.VUE_APP_MANAGEMENT_URL;
    protected kind = Fetch.MANAGEMENT_KIND;
    protected moduleName = Fetch.MANAGEMENT_MODULE_NAME;
    newInstance(): MapSettings {
        return new MapSettings();
    }
}

export const mapSettingsService: MapSettingsService = new MapSettingsService();



